module.exports = __webpack_public_path__ + "img/Inflammation-BRCA_10X_WTA.977bbaf0.png";